import angular from 'angular';

import StatusPanelService from './StatusPanelService';
import StatusPanelController from './StatusPanelController';
import statusPanel from './StatusPanelDirective';

export default angular
  .module('petroCloud.dashboard.statusPanel', [])
  .service('StatusPanelService', StatusPanelService)
  .controller('StatusPanelController', StatusPanelController)
  .directive('statusPanel', statusPanel)
  .name;
